import { Object3D } from "three";
// Reuse objects from a pool to avoid garbage collection
export class ObjectPool {
    constructor(type, size = 0) {
        this.objects = [];
        this.count = 0;
        if (type) {
            this.type = type;
            for (let i = 0; i < size; i++) {
                this.addToPool();
            }
        }
    }
    addToPool() {
        if (this.rootObject instanceof Object3D) {
            this.objects.push(this.rootObject.clone());
        }
        else if (this.type) {
            this.objects.push(new this.type());
        }
    }
    getFromPool() {
        if (this.count >= this.objects.length) {
            this.addToPool();
        }
        return this.objects[this.count++];
    }
    returnToPool(object) {
        if (this.count === 0) {
            console.warn("Pool count is null in ObjectPool.returnToPool");
            return;
        }
        if (object instanceof Object3D) {
            object.visible = false;
            if (object.parent) {
                object.parent.remove(object);
            }
        }
        this.objects[--this.count] = object;
    }
}
